import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Button, CircularProgress, Alert, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api';

export default function CheckoutSuccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');

    const loadStatus = () => {
      if (sessionId) {
        return api.post('/api/platform/subscription/confirm/', { session_id: sessionId })
          .then(res => {
            setStatus(res.data);
            return res.data;
          })
          .catch(() => api.get('/api/platform/subscription/status/').then(r => r.data))
          .then(data => {
            setStatus(data);
            return data;
          });
      }
      return api.get('/api/platform/subscription/status/')
        .then(res => {
          setStatus(res.data);
          return res.data;
        });
    };

    loadStatus()
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [searchParams]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  const sub = status?.subscription || {};
  const subStatus = sub.status || status?.status || 'inactive';
  const plan = sub.plan || status?.plan || 'pro';
  const isTrialing = subStatus === 'trialing';
  const isActive = subStatus === 'active';

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 6, borderRadius: 3, textAlign: 'center' }}>
        <CheckCircleIcon sx={{ fontSize: 80, color: 'success.main', mb: 2 }} />
        <Typography variant="h4" fontWeight={700} gutterBottom>
          {isTrialing ? "Your Free Trial Has Started!" : "Welcome to Firmflow!"}
        </Typography>
        <Typography variant="body1" color="text.secondary" mb={4}>
          {isTrialing
            ? "You have 14 days to explore all features. No payment required during your trial."
            : "Your subscription is now active. Welcome to Firmflow!"}
        </Typography>

        {plan && (
          <Alert severity="success" sx={{ mb: 3, textAlign: 'left' }}>
            <strong>Plan:</strong> {plan.toUpperCase()} &nbsp;|&nbsp;
            <strong>Status:</strong> {(subStatus || '').replace('_', ' ')}
          </Alert>
        )}

        <Box display="flex" gap={2} justifyContent="center">
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/dashboard')}
            sx={{ borderRadius: 2, fontWeight: 700 }}
          >
            Go to Dashboard
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate('/settings/billing-settings')}
            sx={{ borderRadius: 2 }}
          >
            Manage Billing
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
